import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { openPdfBlob, printPdfBlob } from '../../utils/pdf';
import { useApiErrorToast } from '../../hooks/useApiError';

// Generic PDF trigger button. `onFetch` must return a Promise resolving to a
// Blob (e.g. `() => trigger(id).unwrap()` from a lazy blob query).
// Pass `size={null}` for a default-size button, and `action="print"` to send
// the PDF straight to the print dialog instead of opening it.
const PdfButton = ({
  onFetch,
  filename,
  label,
  icon = 'file-pdf',
  variant = 'outline-primary',
  size = 'sm',
  action = 'open',
  className,
}) => {
  const [loading, setLoading] = useState(false);
  const apiErrorToast = useApiErrorToast();

  const handle = async () => {
    setLoading(true);
    try {
      const blob = await onFetch();
      if (action === 'print') {
        printPdfBlob(blob, filename);
      } else {
        openPdfBlob(blob, filename);
      }
    } catch (err) {
      apiErrorToast(err, 'PDF konnte nicht erstellt werden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handle}
      disabled={loading}
    >
      <i className={`fas fa-${icon} me-1`} />
      {label}
    </Button>
  );
};

export default PdfButton;
